import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

      export const updateClientPricingModel = createAsyncThunk('appclientPricingModel/Update', async (data) => {
        
        const response = await axios.post('https://api.zasway.com:8443/ClientPricingModelAssignment/Update', data, {mode:'cors'})
        
        return response
      })

      export const getData = createAsyncThunk('appclientPricingModel/getData', async (params) => {
        
        const response = await axios.post('https://api.zasway.com:8443/ClientPricingModelAssignment/GetTableSummary', params, {mode:'cors'})
         
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })

  export const appclientPricingModelSlice = createSlice({
    name: 'appclientPricingModel',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder
        
        .addCase(getData.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.allData = action.payload.allData
          state.total = action.payload.totalPages
          state.params = action.payload.params
        })
    }
  })
  
  export default appclientPricingModelSlice.reducer
